import { render, staticRenderFns } from "./ReportsTables.vue?vue&type=template&id=b54647d6&scoped=true"
import script from "./ReportsTables.vue?vue&type=script&lang=js"
export * from "./ReportsTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54647d6",
  null
  
)

export default component.exports